import { Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialog } from '@app/shared/models/generic-dialog.model';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';

@Component({
  selector: 'dhl-modal-politics',
  templateUrl: './modal-politics.component.html',
  styleUrls: ['./modal-politics.component.scss']
})
export class ModalPoliticsComponent{

  dialogData: GenericDialog;
  disableButtonTerms: boolean = true;
  public checkValue = false;

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialog) {
    this.dialogData = data;
  }
  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
